export enum RFMConfigLevel {
  BUSINESS_UNIT = "businessUnit",
  PRODUCT_HIERARCHY = "productHierarchy",
}